/**
 * Constantes e query-keys do módulo communityVideos.
 * Fonte única de literais — evita strings mágicas espalhadas.
 */

export const VIDEO_PAGE_SIZE = 10;

export const VIDEO_SORT = Object.freeze({
  RELEVANT: 'relevant', // "Mais relevantes"
  RECENT: 'recent',     // "Atualizações"
});

export const VIDEO_SOURCE = Object.freeze({
  YOUTUBE: 'youtube',
  UPLOAD: 'upload',
});

export const VIDEO_STATUS = Object.freeze({
  ACTIVE: 'active',
  PROCESSING: 'processing',
  REMOVED: 'removed',
});

// Query-key factory (React Query) — chaveado por seção + sort + tópico.
export const videoKeys = {
  all: ['communityVideos'],
  feed: (section, sort, topic) => [...videoKeys.all, 'feed', section, sort, topic ?? 'all'],
  userVideos: (userId) => [...videoKeys.all, 'userVideos', userId || 'anonymous'],
  userLikes: () => [...videoKeys.all, 'userLikes'],
};

// Seções (a qual coleção o vídeo pertence).
export const VIDEO_SECTION = Object.freeze({
  RELEVANT: 'relevant', // "Mais relevantes" (só YouTube)
  UPDATES: 'updates',   // "Atualizações" (YouTube + galeria)
});
